import { render, staticRenderFns } from "./VInput.vue?vue&type=template&id=263c84f2&scoped=true"
import script from "./VInput.vue?vue&type=script&lang=js"
export * from "./VInput.vue?vue&type=script&lang=js"
import style0 from "./VInput.vue?vue&type=style&index=0&id=263c84f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263c84f2",
  null
  
)

export default component.exports